import { render } from "./EventParticipants.vue?vue&type=template&id=0f0a17be&scoped=true"
import script from "./EventParticipants.vue?vue&type=script&lang=js"
export * from "./EventParticipants.vue?vue&type=script&lang=js"

import "./EventParticipants.vue?vue&type=style&index=0&id=0f0a17be&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0a17be"]])

export default __exports__